import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip
} from "@mui/material";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import StatusBadge from "components/badge/StatusBadge";
import CustomTabs from "components/CustomTabs";
import DocumentManagement from "components/DocumentManagement";

const tabs = ["Change Information", "Documents"]

const ViewChange = (props) => {
    const { open, handleClose, rowData, isLoading } = props;
    const [tabValue, setTabValue] = useState(0);

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: 0.5,
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mb: 2,
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const getIssueText = (isIssued) => {
        if (isIssued === true) return "Yes";
        if (isIssued === false) return "No";
        return "N/A";
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View Change Details
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <CustomTabs tabValue={tabValue} handleTabChange={handleTabChange} tabs={tabs} />
                    {tabValue === 0 &&
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: "3px",
                                border: "1px solid #e5e7eb",
                                backgroundColor: "#fff",
                                p: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 1,
                                }}
                            >
                                <Typography sx={{
                                    fontWeight: 600,
                                    fontSize: "20px",
                                    fontFamily: "Outfit, sans-serif",
                                    color: "#0A0A0C"
                                }}>
                                    Change Information
                                </Typography>
                            </Box>

                            <Divider sx={{ mb: 3 }} />

                            <CardContent sx={{ pt: 0 }}>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <Grid container spacing={1}>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Change ID:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                                    <Avatar
                                                        sx={{
                                                            width: 30,
                                                            height: 30,
                                                            bgcolor: getAvatarColor(rowData?.customId || ""),
                                                            color: "#fff",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            p: 0,
                                                            m: 0
                                                        }}
                                                    >
                                                        {rowData?.customId?.[0] || "C"}
                                                    </Avatar>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.customId ?? "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Change Request Form No:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.changeRequestNo ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Raised Type:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.raisedType ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Contract / Package:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.contractPackage ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Requestor Name:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.requestorName ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Current Status:</strong>
                                                </Typography>
                                                <Box sx={{ mb: 2 }}>
                                                    <StatusBadge status={rowData?.currentStatus} />
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Change Type:</strong>
                                                </Typography>
                                                <Chip
                                                    label={rowData?.changeType ?? "N/A"}
                                                    sx={{
                                                        backgroundColor: "#e3f2fd",
                                                        color: "#1976d2",
                                                        fontWeight: 500
                                                    }}
                                                />
                                            </Grid>

                                            <Grid size={{ xs: 12 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Change Title / Brief:</strong>
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: "18px",
                                                    color: "#111827",
                                                    fontWeight: 600,
                                                    mb: 2,
                                                    fontFamily: "Outfit, sans-serif",
                                                    padding: "8px",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "4px",
                                                    borderLeft: "4px solid #0E73F6"
                                                }}>
                                                    {rowData?.changeTitle ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Description:</strong>
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: "16px",
                                                    color: "#111827",
                                                    fontWeight: 500,
                                                    mb: 2,
                                                    fontFamily: "Outfit, sans-serif",
                                                    padding: "12px",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    borderLeft: "4px solid #0E73F6",
                                                    minHeight: "60px",
                                                    lineHeight: "1.5"
                                                }}>
                                                    {rowData?.description ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Date Raised:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={{
                                                        ...valueStyle,
                                                        // // color: "#111827",
                                                        // fontWeight: 600
                                                    }}>
                                                        {rowData?.dateRaised ?
                                                            moment(rowData.dateRaised).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Reason/Justification:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.reasonJustification ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Clause/Contract Reference:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.clauseContractReference ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Scope Impact:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.scopeImpact ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Time Impact:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.timeImpact ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Cost Impact:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.costImpact ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Amount Proposed:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.amountProposed ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Forwaded to (for action):</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.forwardedTo ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Estimated Change Amount:</strong>
                                                </Typography>
                                                <Typography sx={{
                                                    ...valueStyle,
                                                    // color: "#d32f2f",
                                                    // fontWeight: 600
                                                }}>
                                                    {rowData?.changeAmount ? `₹${rowData.changeAmount}` : "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Recommended Change Amount:</strong>
                                                </Typography>
                                                <Typography sx={{
                                                    ...valueStyle,
                                                    // color: "#111827",
                                                    // fontWeight: 600
                                                }}>
                                                    {rowData?.recommendedChangeAmount ? `₹${rowData.recommendedChangeAmount}` : "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Certified Amount:</strong>
                                                </Typography>
                                                <Typography sx={{
                                                    ...valueStyle,
                                                    // color: "#111827",
                                                    // fontWeight: 600
                                                }}>
                                                    {rowData?.certifiedAmount ? `₹${rowData.certifiedAmount}` : "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Final Status of Change:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.finalStatus ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Days of Internal Approval:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.daysForInternalApproval ? `${rowData.daysForInternalApproval} days` : "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Issue (Y/N):</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {getIssueText(rowData?.isIssued)}

                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Days for Change Order Issuance:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.daysForChangeOrderIssuance ? `${rowData.daysForChangeOrderIssuance} days` : "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Expected date of closure:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={{
                                                        ...valueStyle,
                                                        // color: "#111827",
                                                        // fontWeight: 600
                                                    }}>
                                                        {rowData?.expectedClosureDate ?
                                                            moment(rowData.expectedClosureDate).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Approval Date:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={{
                                                        ...valueStyle,
                                                        // color: "#111827",
                                                        // fontWeight: 600
                                                    }}>
                                                        {rowData?.approvalDate ?
                                                            moment(rowData.approvalDate).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Issue Date:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={{
                                                        ...valueStyle,
                                                        // color: "#111827",
                                                        // fontWeight: 600
                                                    }}>
                                                        {rowData?.issueDate ?
                                                            moment(rowData.issueDate).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    }

                    {tabValue === 1 &&
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={rowData?.changeId} entityType="Change" customId={rowData?.customId} isView={true} />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ViewChange;